<template>
  <div class="order-details__status">
    <div class="status bg-color__fff">
      <el-steps :active="active" align-center>
        <el-step title="买家下单" :description="form.startTime" :icon="active >= 1 ? 'el-icon-success' : ''" />
        <el-step title="买家付款" :description="form.paymentTime" :icon="active >= 2 ? 'el-icon-success' : ''" />
        <el-step title="发货" :description="form.shippingTime" :icon="active >= 3 ? 'el-icon-success' : ''" />
        <el-step title="买家确认收货" :description="form.deliveryTime" :icon="active >= 4 ? 'el-icon-success' : ''" />
        <el-step title="订单完成时间" :description="form.finalTime" :icon="active >= 5 ? 'el-icon-success' : ''" />
      </el-steps>
    </div>
    <div class="info pad-mar__title">
      <h3 class="title">订购人信息</h3>
      <el-form :model="form" label-width="auto">
        <el-form-item label="会员名称：">
          {{ form.vipName }}
        </el-form-item>
        <el-form-item label="订单号：">
          {{ form.orderNumber }}
        </el-form-item>
        <el-form-item label="订单归属商家：">
          {{ form.appName }}
        </el-form-item>
        <el-form-item label="订单金额：">
          {{ form.orderMoney }}
        </el-form-item>
        <el-form-item label="调价金额：">
          {{ form.priceAdjustmentMoney | formatMoney }}
        </el-form-item>
        <el-form-item label="促销折扣金额：">
          {{ form.discountMoney | formatMoney }}
        </el-form-item>
        <el-form-item label="积分抵扣金额：">
          {{ form.intergralMoney | formatMoney }}
          <span class="intergral" v-if="form.integral">
            {{ form.integral }}积分
          </span>
        </el-form-item>
        <el-form-item label="订单实收金额：">
          {{ form.money | formatMoney }}
        </el-form-item>
        <el-form-item label="调价说明：">
          {{ form.des }}
        </el-form-item>
        <el-form-item label="电子订单申报结果：">
          {{ form.orderDeclaration }}
          <el-button v-if="form.orderState === '20' && form.refundType === '0'" v-html="'申报电子订单'" class="sub-color"
            @click="declareOrder(1)" round />
        </el-form-item>
        <el-form-item label="支付单申报结果：">
          {{ form.paymentDeclaration }}
          <el-button v-if="form.orderState === '20' && form.refundType === '0'" v-html="'申报支付订单'" class="d5"
            @click="declareOrder(2)" round />
        </el-form-item>
        <el-form-item label="海关状态：">
          <span>{{ form.customsStatus }}</span>
        </el-form-item>
      </el-form>
      <el-form :model="form" label-width="auto">
        <el-form-item label="收件人姓名：">
          {{ form.reciverName }}
        </el-form-item>
        <el-form-item label="收件人电话：">
          {{ form.reciverPhone }}
        </el-form-item>
        <el-form-item label="收件人地址：">
          {{ form.reciverAddr }}
        </el-form-item>
        <el-form-item label="备注信息：">
          {{ form.info }}
        </el-form-item>
        <!-- <el-form-item label="订购人姓名："> -->
        <!-- {{ form.buysName }} -->
        <!-- <span class="goods-name">
            <el-input
              placeholder="请输入"
              suffix-icon="el-icon-edit"
              @change="modify('name', form.buysName)"
              v-model="form.buysName"
            />
          </span> -->
        <!--          <span class="red" style="margin-left: 3rem"-->
        <!--            >{{ form.buysNameChange }}(变更后)</span-->
        <!--          >-->
        <!-- </el-form-item> -->
        <p class="ellipses">
          <el-form-item label="订购人姓名：">
            <span class="goods-name">
              <el-input placeholder="订购人姓名" suffix-icon="el-icon-edit" class="editor"
                @change="modify('name', form.buysName)" v-model="form.buysName" />
            </span>
          </el-form-item>
        </p>
        <el-form-item label="订购人手机号：">
          {{ form.buysPhone }}
        </el-form-item>
        <p class="ellipses">
          <el-form-item label="订购人身份证号码">
            <span class="goods-name">
              <el-input placeholder="订购人姓名" suffix-icon="el-icon-edit" class="editor"
                @change="modify('idcard', form.buysIdCard)" v-model="form.buysIdCard" />
            </span>
          </el-form-item>
        </p>
        <!-- <el-form-item label="订购人身份证号码：">
          {{ form.buysIdCard }} -->
        <!--          <span class="red" style="margin-left: 3rem"-->
        <!--            >{{ form.buysIdCardChange }}(变更后)</span-->
        <!--          >-->
        <!-- </el-form-item> -->
        <!--        <el-form-item label="三单比对结果：" class="red">-->
        <!--          {{ form.tipsInfo }}-->
        <!--        </el-form-item>-->
        <el-form-item label="支付方式：">
          {{ form.payment }}
        </el-form-item>
        <el-form-item label="支付单号：">
          {{ form.payMentOrder }}
        </el-form-item>
        <el-form-item label="税费：">
          {{ form.traff | formatMoney }}
        </el-form-item>
      </el-form>
    </div>
    <div class="goods-info pad-mar__title" v-min-height>
      <h3 class="title">商品信息</h3>
      <div class="table-wrapper">
        <div class="table">
          <el-table :data="tableData" border :header-cell-style="{
            height: '2.5rem',
            color: '#333',
            background: '#f3f3f3',
            borderRight: 0,
          }" :cell-style="{
  color: '#606060',
}" class="no-hover no-pad__bor">
            <el-table-column fixed label="商品标题" align="center" width="400" class-name="visible">
              <div slot-scope="scope">
                <div class="order-details">
                  <div class="box" :class="scope.row.goodsList.length > 1 ? 'bor-bottom' : ''"
                    v-for="(item, index) in scope.row.goodsList" :key="index">
                    <el-image :src="item.imgUrl" class="goods-img">
                      <div slot="error" class="image-slot">
                        <i class="iconfont icon-tupian" />
                      </div>
                    </el-image>
                    <div class="caption">
                      <p class="ellipses">
                        <el-tooltip effect="light" placement="bottom-start" :content="item.cnName">
                          <span class="goods-name"> {{ item.cnName }}</span>
                        </el-tooltip>
                      </p>
                      <p class="ellipses">
                        <el-tooltip effect="light" placement="bottom-start" :content="item.enName">
                          <span class="goods-name"> {{ item.enName }}</span>
                        </el-tooltip>
                      </p>
                      <p class="ellipses">
                        <el-tooltip effect="light" placement="bottom-start" :content="item.sku">
                          <span class="goods-name">SKU编码：{{ item.sku }}</span>
                        </el-tooltip>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="单价（元)">
              <div slot-scope="scope">
                <div class="order-details">
                  <div :class="scope.row.goodsList.length > 1
                    ? 'bor-bottom set-height'
                    : 'box'
                    " v-for="(item, index) in scope.row.goodsList" :key="index">
                    {{ item.goodsPirce | formatMoney }}
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="数量">
              <div slot-scope="scope">
                <div class="order-details">
                  <div :class="scope.row.goodsList.length > 1
                    ? 'set-height bor-right bor-bottom'
                    : 'box'
                    " v-for="(item, index) in scope.row.goodsList" :key="index">
                    {{ item.num * item.salesQuantity }}
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="积分优惠">
              <div slot-scope="scope">
                <div class="order-details">
                  <p>
                    {{ form.intergralMoney | formatMoney }}
                  </p>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="活动优惠">
              <div slot-scope="scope">
                <div class="order-details">
                  <p>
                    {{ form.discountMoney | formatMoney }}
                  </p>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="运费">
              <div slot-scope="scope">
                <div class="order-details">
                  <p>
                    {{ form.shipping | formatMoney }}
                  </p>
                </div>
              </div>
            </el-table-column>
            <el-table-column align="center" label="订单金额">
              <div slot-scope="scope">
                <div class="order-details">
                  <p>
                    {{ form.money | formatMoney }}
                  </p>
                </div>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="logistics-infomation pad-mar__title" v-if="form.logisticsInfo">
      <h3 class="title">物流信息</h3>
      <div class="time-line">
        <el-timeline :reverse="false">
          <el-timeline-item :key="index" v-for="(item, index) in form.logisticsInfo" :timestamp="item.dateTime"
            placement="top" :icon="index === 0 ? 'iconfont icon-yuandian' : ''">
            <!--            <div class="coordinate">-->
            <!--              <i class="iconfont icon-weizhi"></i>-->
            <!--              <span class="city">上海市</span>-->
            <!--            </div>-->
            <span class="info-status">{{ item.flag }} </span>
            <p class="tips">{{ item.des }}</p>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div class="invoice-information pad-mar__title" v-if="form.invoiceInfo">
      <h3 class="title">发票信息</h3>
      <el-form :model="form.invoiceInfo" label-width="auto">
        <el-form-item label="发票抬头：">{{ form.invoiceInfo.title }}
        </el-form-item>
        <el-form-item label="纳税号：">{{ form.invoiceInfo.taxNumber }}
        </el-form-item>
        <el-form-item label="公司电话：">{{ form.invoiceInfo.phone }}
        </el-form-item>
        <el-form-item label="账号：">{{ form.invoiceInfo.account }}
        </el-form-item>
        <el-form-item label="开户行：">{{ form.invoiceInfo.bank }}
        </el-form-item>
        <el-form-item label="地址：">{{ form.invoiceInfo.addr }}</el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orderDetails',
  data() {
    this.keyMap = {
      order_info: {
        name: 'form',
        app_name: 'appName',
        add_time: 'startTime',
        payment_time: 'paymentTime',
        delivery_time: 'deliveryTime',
        shipping_time: 'shippingTime',
        finnshed_time: 'finalTime',
        member_name: 'vipName',
        pay_sn: 'orderNumber',
        goods_amount: 'orderMoney',
        adjust_amount: 'priceAdjustmentMoney',
        discount_amount: 'discountMoney',
        consumption_integral: 'integral',
        points_price: 'intergralMoney',
        order_amount: 'money',
        adjust_explain: 'des',
        delivery_code: 'deliveryCode',
        payment_declaration: 'paymentDeclaration',
        order_declaration: 'orderDeclaration',
        customs_status: 'customsStatus',
        action_type: 'actionType',
        reciver_name: 'reciverName',
        reciver_phone: 'reciverPhone',
        address_detail: 'reciverAddr',
        order_message: 'info',
        true_name: 'buysName',
        member_mobile: 'buysPhone',
        identity_card: 'buysIdCard',
        application_result: 'tipsInfo',
        payment_code: 'payment',
        paytransactionid: 'payMentOrder',
        goods_list: 'goodsList',
        goods_image: 'imgUrl',
        goods_name: 'cnName',
        goods_en: 'enName',
        goods_num: 'num',
        sales_quantity: 'salesQuantity',
        goods_sku: 'sku',
        goods_price: 'goodsPirce',
        express_message: 'logisticsInfo',
        sign: 'flag',
        date_time: 'dateTime',
        describe: 'des',
        order_traff: 'traff',
        order_state: 'orderState',
        order_type: 'orderType',
        platform_name: 'platformName',
        refund_type: 'refundType',
        invoice_info: {
          name: 'invoiceInfo',
          bank_account: 'account',
          company_address: 'addr',
          company_name: 'title',
          company_tell: 'phone',
          deposit_bank: 'bank',
          tax_number: 'taxNumber',
        },
        shipping_fee: 'shipping',
      },
    }
    return {
      active: 0,
      form: {},
      tableData: [],
    }
  },
  watch: {
    $route: {
      handler: function (to) {
        this.getOrderDetilsInfo({ order_id: to.query.id })
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 获取订单详情
     * @param params
     */
    getOrderDetilsInfo(params) {
      this.api.getOrderDetailsInfo(params).then((res) => {
        this.utils._modifyObjKey(res, this.keyMap)
        this.form = res.form
        this.tableData = [];
        this.tableData.push({
          goodsList: this.form.goodsList,
        })
        this.inActive()
      })
    },
    /**
     * 计算active
     */
    inActive() {
      const form = this.form
      const calcActive = () => {
        this.active += 1
      }
      for (let key in form) {
        switch (key) {
          case 'startTime':
            form[key] !== '' && calcActive()
            break
          case 'paymentTime':
            form[key] !== '' && calcActive()
            break
          case 'deliveryTime':
            form[key] !== '' && calcActive()
            break
          case 'shippingTime':
            form[key] !== '' && calcActive()
            break
          case 'finalTime':
            form[key] !== '' && calcActive()
            break
        }
      }
    },
    /**
     * 修改身份证和姓名
     *
     */
    modify(type, item) {
      let data = {
        change_type: type,
        changed_value: item,
        order_id: this.$route.query.id,
      }
      this.api.modifyOrder(data).then((res) => {
        this.$notify({
          type: 'success',
          message: '修改成功！🙂',
        })
      })
    },
    /**
     * 申报订单
     * @param type
     */
    declareOrder(type) {
      const { orderType, platformName, deliveryCode, actionType } = this.form
      const succesCallback = (res) => {
        this.getOrderDetilsInfo({
          order_id: this.$route.query.id,
        })
        this.$notify({
          type: 'success',
          message: res.message,
        })
        this.active = 0
      }
      if (type === 1) {
        this.api
          .declareOrder({
            order_id: this.$route.query.id,
            platform_name: platformName,
            order_type: orderType,
          })
          .then((res) => {
            succesCallback(res)
          })
      } else {
        this.api
          .declarePaymentOrder({
            order_id: this.$route.query.id,
            delivery_code: deliveryCode,
            action_type: actionType,
          })
          .then((res) => {
            succesCallback(res)
          })
      }
    },
  },
}
</script>

<style lang="scss">
.order-details__status {
  .el-steps {
    width: 80%;
  }

  .el-form-item {
    margin-bottom: 0;
  }

  .el-form-item__label {
    color: colors('a4');
  }

  .status {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 12.5rem;
    margin-bottom: 1.3rem;
  }

  .el-step {
    top: 25px;
  }

  .el-step__icon.is-icon {
    width: initial;
  }

  .el-icon-success {
    color: colors('bg-sub');
    font-size: 24px !important;
  }

  .el-step__line {
    background-color: #f3f3f3;
  }

  .el-step__title {
    position: relative;
    top: -70px;
    left: 50%;
    transform: translateX(-50%);

    &.is-finish {
      top: -76px;
    }
  }

  .el-step__title.is-finish {
    color: #010101;
  }

  .el-step__head.is-finish {
    color: colors('bg-sub');
    border-color: colors('bg-sub');
  }

  .el-step__icon.is-text {
    width: 12px;
    height: 12px;
    background-color: #e6e6e6;
    border: 0;

    .el-step__icon-inner {
      font-size: 0;
    }
  }

  .el-step__description {
    margin-top: -20px;
    white-space: nowrap;
    color: #a4a4a4;

    &.is-finish {
      color: #010101;
      margin-top: -26px;
    }
  }

  .info {
    min-height: 38.8rem;

    .intergral {
      width: 4.4rem;
      height: 1.3rem;
      background-color: colors('bg-main');
      border-radius: 0.6rem;
      color: #fff;
      display: inline-block;
      line-height: 1.3rem;
      text-align: center;
    }

    .el-form {
      display: inline-block;
      margin-right: 10rem;
      vertical-align: top;
    }
  }

  .table {
    padding-left: 0;
    padding-right: 13rem;

    .order-details {
      padding-top: 0;
    }
  }

  .logistics-infomation {
    min-height: 38.8rem;
  }

  .time-line {
    padding-left: 100px;
  }

  .el-timeline-item__tail {
    border-color: #f3f3f3;
  }

  .el-timeline-item__node {
    background-color: #f3f3f3;
  }

  .el-timeline-item__wrapper {
    padding-left: 80px;
  }

  .info-status {
    position: absolute;
    top: 0;
    left: 20px;
  }

  .icon-weizhi {
    font-size: 1.5rem;
    vertical-align: sub;
  }

  .city {
    padding-left: 1rem;
    font-size: 0.9rem;
  }

  .coordinate {
    position: absolute;
    top: -5px;
    left: -100px;
  }

  .invoice-information {
    min-height: 26.3rem;
  }

  .icon-yuandian {
    font-size: 1.5rem;
    color: colors('bg-sub');
  }
}

.ellipses {
  &.relative {
    padding-right: 1rem;
  }

  input {
    height: initial;
    line-height: initial;
    background: transparent;
    padding-left: 0;
    padding-right: 20px;
    @extend .ellipses;
  }

  .el-input__icon {
    line-height: initial;
    padding-left: 1rem;
  }
}
</style>
